import { TPayload, TActionType } from '../../repositories/cian-chat-bot/entities/action_buttons/ActionButton';
import {
  fetchProcessActionButtons,
  TProcessActionButtonsResponse,
} from '../../repositories/cian-chat-bot/v2/process-action-buttons';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

export type { TPayload as TChatbotPayload, TActionType as TChatbotActionType };

const DEFAULT_ERROR_MESSAGE = 'Не удалось получить кнопки чатбота';

export async function fetchChatbotActionButtons(
  { httpApi, logger, telemetry }: TContext,
  payload: TPayload,
): Promise<void> {
  try {
    const { statusCode, response }: TProcessActionButtonsResponse = await fetchProcessActionButtons({
      httpApi,
      parameters: {
        payload,
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotActionButtonsFail);

    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v2/process-action-buttons/',
      parameters: JSON.stringify({ payload }),
    });
  }
}
